import React, { useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Collapse, IconButton, Box, Typography
} from '@mui/material';
import {
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon
} from '@mui/icons-material';
import AllProfilesGridModel from '../../../models/company/allProfiles/response/AllProfilesGridModel';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { RoleEnum } from '../../../models/enums/RoleEnum';

interface CandidateRowProps {
    candidate: AllProfilesGridModel;
    index: number;
    loggedInUser: any;
    roleId: number;
    statusUpdate: (candidate: AllProfilesGridModel) => void;
    scheduleInterview: (candidate: AllProfilesGridModel) => void;
    viewRating: (candidate: AllProfilesGridModel) => void;
    viewRecordings: (candidate: AllProfilesGridModel) => void;
    viewHistory: (candidateId: string) => void;
    copyClipboard: (value: string) => void;
}

const AllProfilesGridChildComponent: React.FC<CandidateRowProps> = ({
    candidate,
    index,
    loggedInUser,
    roleId,
    statusUpdate,
    scheduleInterview,
    viewRating,
    viewRecordings,
    viewHistory,
    copyClipboard
}) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* MAIN ROW */}
            <TableRow
                sx={{
                    backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5'
                }}
            >
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)} className='grid-action-icon-buttons'>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{candidate.candidateName}</TableCell>
                <TableCell>{candidate.designationName}</TableCell>
                <TableCell>{candidate.recruiterName}</TableCell>
                <TableCell>{candidate.interviewDate}</TableCell>
                <TableCell>{candidate.totalRating}</TableCell>
                <TableCell>{candidate.statusName}</TableCell>
                <TableCell style={{display: 'inline-flex'}}>
                    {!candidate.isRated && (
                        <IconButton onClick={() => scheduleInterview(candidate)} title="Schedule Interview" className='grid-action-icon-buttons'>
                            <i className="fa fa-calendar-alt grid-icon blue"></i>
                        </IconButton>
                    )}
                    {candidate.isRated && (
                        <>
                            <IconButton onClick={() => viewRating(candidate)} title="Rating" className='grid-action-icon-buttons'>
                                <i className="fa fa-star grid-icon blue"></i>
                            </IconButton>
                            <IconButton onClick={() => viewRecordings(candidate)} title="Recordings" className='grid-action-icon-buttons'>
                                <i className="fa fa-video-camera grid-icon blue"></i>
                            </IconButton>
                        </>
                    )}
                    <IconButton onClick={() => { statusUpdate(candidate); }} title="Update Status" className='grid-action-icon-buttons'>
                        <i className="fa fa-check grid-icon blue"></i>
                    </IconButton>
                    <IconButton onClick={() => viewHistory(candidate.candidateId)} title="View History" className='grid-action-icon-buttons'>
                        <i className="fa fa-history grid-icon blue"></i>
                    </IconButton>
                </TableCell>
            </TableRow>
            {/* COLLAPSIBLE CHILD ROW */}
            <TableRow>
                <TableCell
                    className="no-padding-cell"
                    colSpan={8}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Table size="small" aria-label="details" className='child-grid-wrapper'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Email Id</TableCell>
                                        <TableCell>Mobile No</TableCell>
                                        <TableCell>Jobcode</TableCell>
                                        <TableCell>Created Date</TableCell>
                                        <TableCell>Meeting URL</TableCell>
                                        <TableCell>Recording URL</TableCell>
                                        {(Number(loggedInUser.roleId) === Number(RoleEnum.Administrator) || Number(loggedInUser.roleId) === Number(RoleEnum.IAIRecruiter)) &&
                                            <TableCell>IAI Recruiter:</TableCell>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>{candidate.emailId}</TableCell>
                                        <TableCell>
                                            <span>{candidate.mobileNumber}</span>
                                            <IconButton color="primary" className="grid-icon-copy-button" onClick={() => { copyClipboard(candidate.mobileNumber.toString()); }}>
                                                <ContentCopyOutlinedIcon className="grid-icon-copy" />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>{candidate.jobCode}</TableCell>
                                        <TableCell>{candidate.createdDateString}</TableCell>
                                        <TableCell><a href={candidate.zoomMeetingUrl} target="_blank" title={candidate.zoomMeetingUrl}>Join Meeting</a></TableCell>
                                        <TableCell><a href={candidate.zoomRecordingUrl} target="_blank" title={candidate.zoomRecordingUrl}>Recording URL ({candidate.passcode})</a></TableCell>
                                        {(Number(loggedInUser.roleId) === Number(RoleEnum.Administrator) || Number(loggedInUser.roleId) === Number(RoleEnum.IAIRecruiter)) &&
                                            <TableCell>{candidate.adminName}</TableCell>
                                        }
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};
export default AllProfilesGridChildComponent;
